// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__JKyDs","dragIcon":"SortableItem_dragIcon__3QxX0","disabled":"SortableItem_disabled__D5b9M"};